import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { StoreService } from '../store.service';
var CasePracticeReportNew2Component = (function () {
    function CasePracticeReportNew2Component(commonService, apiService, route, router, storeService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.storeService = storeService;
        this.itemClickEnable = false;
        this.assetsRoute = "../../assets";
    }
    CasePracticeReportNew2Component.prototype.ngOnInit = function () {
        var _this = this;
        var that = this;
        this.isShowReportLv = false;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.practiceId = params["practiceId"];
            _this.exerciseId = params["exerciseId"];
            _this.learningPathId = params["learningPathId"];
            //practiceId = 9898  决策
            _this.assetsRoute = _this.commonService.setAssetsRoute(_this.assetsRoute);
            _this.apiService
                .ajax({
                type: "get",
                url: "/wx/api/report/" + _this.practiceId,
            })
                .subscribe(function (result) {
                _this.practiceMetaId = result.practiceMetaId;
                _this.report = result.reports[0].kas;
                if (_this.report.length == 0) {
                    _this.redo();
                    // return false;
                }
                else {
                    _this.reportName = result.reports[0].name;
                    _this.finished = result.allExerciseFinished;
                    $.ajax({
                        url: "/sr/insideapi/getlevel",
                        type: "post",
                        dataType: "json",
                        contentType: "application/json;charset=utf-8",
                        data: JSON.stringify(_this.getKaList(result.reports[0])),
                        async: false,
                        headers: {
                            'transtalen-token': localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                            'transtalenuserid': localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
                        },
                        success: function (result) {
                            if (result && result != "") {
                                that.reportKAData = result;
                                that.targetShow = 1;
                            }
                            else {
                                that.targetShow = 0;
                            }
                        },
                        error: function (er) {
                            that.targetShow = 0;
                            if (er.status === 401 && Number(er.responseJSON.code) === 106) {
                                that.storeService.notification.notAuthed.next(true);
                            }
                        },
                    });
                    if (result.reports[0].name == "组织与计划") {
                        _this.mode = 2;
                        if (that.targetShow == 0) {
                            _this.lvCls = _this.mode + "";
                        }
                        else {
                            _this.lvCls = _this.mode + " bgBlur";
                        }
                        _this.starPicUrl = "/casepracticepando/star2.png";
                    }
                    else {
                        _this.mode = 1;
                        if (that.targetShow == 0) {
                            _this.lvCls = _this.mode + "";
                        }
                        else {
                            _this.lvCls = _this.mode + " bgBlur";
                        }
                        _this.starPicUrl = "/casepracticeteam/star_report.png";
                    }
                    if (that.targetShow === 0) {
                        _this.isShowReportLv = false;
                    }
                    else {
                        _this.isShowReportLv = true;
                    }
                    setTimeout(function () {
                        _this.itemClickEnable = true;
                    }, 500);
                }
                // //对象赋值并显示等级组件
                // this.reportKAData = this.getKaList(result.reports[0]);
                // this.isShowReportLv = true;
            });
            _this.apiService
                .ajax({
                type: "get",
                url: "/wx/api/tutor/8",
            })
                .subscribe(function (result) {
                _this.tutor = result.tutor;
                _this.optimum = result.optimum;
            });
            _this.apiService
                .ajax({
                type: "get",
                url: "/sr/learningtour",
            })
                .subscribe(function (result) {
                _this.learningTour = result;
            });
        });
        this.analysisBoxShow = false;
        this.starShow = false;
        this.pathClickable = true;
    };
    CasePracticeReportNew2Component.prototype.ngAfterViewInit = function () {
        //修改层的 left
        setTimeout(function () {
            $("#shade").css("left", "0");
        }, 1000);
        this.commonService.initPage({
            backgroundColor: "white",
        });
    };
    /*
    格式化KA对象方法
     report：传递一个报告对象
   */
    CasePracticeReportNew2Component.prototype.getKaList = function (report) {
        var kaJson = {
            id: report.id,
            name: report.name,
            type: report.type,
            kas: {},
            exercisesId: this.exerciseId,
            questionId: null,
            optionId: null,
        };
        if (report) {
            for (var i = 0; i < report.kas.length; i++) {
                var kaItem = report.kas[i];
                if (kaItem) {
                    //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
                    kaJson.kas[kaItem.name] = kaItem.value;
                }
            }
        }
        return kaJson;
    };
    CasePracticeReportNew2Component.prototype.close = function () {
        var _this = this;
        if (this.reportName == "授权") {
            var link = [
                this.learningPathId,
                this.practiceMetaId,
                "case-practice-authorization",
            ];
            if (this.type) {
                this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                this.router.navigate(link);
            }
        }
        else if (this.reportName == "决策") {
            this.apiService
                .ajax({
                type: "get",
                url: "/sr/learningtour",
            })
                .subscribe(function (result) {
                _this.learningTour = result;
                // if (this.learningTour.learning_path_metas[0].id == 16){
                //     this.learningPathId = this.learningTour.learning_path_metas[0].learningPathId;
                //     let link = [this.learningPathId, 10,'case-practice-influence'];
                //     this.router.navigate(link);
                //
                // }
                for (var i = 0, len = _this.learningTour.learning_path_metas.length; i < len; i += 1) {
                    if (_this.learningTour.learning_path_metas[i].id == 16) {
                        _this.learningPathId = _this.learningTour.learning_path_metas[i].learningPathId;
                        var link = [_this.learningPathId, 10, "case-practice-influence"];
                        if (_this.type) {
                            _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                        }
                        else {
                            _this.router.navigate(link);
                        }
                    }
                }
            });
            //let link = [this.learningPathId, 10,'case-practice-influence'];
            //this.router.navigate(link);
        }
        else {
            var link = [this.learningPathId, this.practiceMetaId, "case-practice"];
            if (this.type) {
                this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                this.router.navigate(link);
            }
        }
    };
    CasePracticeReportNew2Component.prototype.subWrapOneOut = function () {
        $("#subWrapOne").fadeOut(function () {
            $("#subWrapTwo").fadeIn();
            $("#btnWrap").fadeIn();
        });
    };
    CasePracticeReportNew2Component.prototype.tourReviewBoxIn = function () {
        $("#tourReviewShade").fadeIn();
        $("#tourReviewBox").fadeIn();
        $("#closeBtn1").fadeIn();
        this.pathClickable = false;
    };
    CasePracticeReportNew2Component.prototype.tourReviewBoxOut = function () {
        $("#tourReviewShade").fadeOut();
        $("#tourReviewBox").fadeOut();
        $("#closeBtn1").fadeOut();
        this.pathClickable = true;
    };
    CasePracticeReportNew2Component.prototype.bestPathIn = function () {
        if (!this.pathClickable) {
            return;
        }
        $("#bestPathBox").fadeIn();
        $("#closeBtn2").fadeIn();
        $("#shade").fadeIn();
    };
    CasePracticeReportNew2Component.prototype.bestPathOut = function () {
        $("#bestPathBox").fadeOut();
        $("#closeBtn2").fadeOut();
        $("#shade").fadeOut();
    };
    CasePracticeReportNew2Component.prototype.redo = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/wx/api/resetpid/" + this.practiceId,
        })
            .subscribe(function (result) {
            setTimeout(function () {
                var link = [
                    "case-practice-hotel",
                    _this.practiceId,
                    _this.exerciseId,
                    _this.learningPathId,
                ];
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            }, 50);
            //this.tutor = result.tutor;
            //this.optimum = result.optimum;
        });
    };
    CasePracticeReportNew2Component.prototype.analysisBoxIn = function (i) {
        if (!this.itemClickEnable) {
            return false;
        }
        var _this = this;
        this.currentName = this.report[i].name;
        this.currentDescription = this.report[i].description;
        this.currentTotal = this.report[i].value;
        this.currentAnalysis = this.report[i].analysis;
        $("#analysisShade").fadeIn();
        // 滚动到订端
        $("#analysisContent").scrollTop(0);
        // $('#analysisBox').fadeIn();
        this.analysisBoxShow = true;
        $("subWrapTwo").css({ oveflow: "hidden" });
        setTimeout(function () {
            _this.starShow = true;
        }, 300);
        this.pathClickable = false;
    };
    CasePracticeReportNew2Component.prototype.analysisBoxOut = function () {
        $("#analysisShade").fadeOut();
        this.analysisBoxShow = false;
        $("subWrapTwo").css({ oveflow: "scroll" });
        this.starShow = false;
        this.pathClickable = true;
    };
    CasePracticeReportNew2Component.prototype.goToList = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/sr/learningtour",
        })
            .subscribe(function (result) {
            _this.learningTour = result;
            // console.log(this.learningTour.learning_path_metas[0].id);
            for (var i = 0, len = _this.learningTour.learning_path_metas.length; i < len; i += 1) {
                if (_this.learningTour.learning_path_metas[i].id == 16) {
                    _this.learningPathId = _this.learningTour.learning_path_metas[i].learningPathId;
                    var link = [_this.learningPathId, 10, "case-practice-influence"];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                }
            }
            // if (this.learningTour.learning_path_metas[0].id == 16){
            //     this.learningPathId = this.learningTour.learning_path_metas[0].learningPathId;
            //     let link = [this.learningPathId, 10,'case-practice-influence'];
            //     this.router.navigate(link);
            // }
        });
    };
    CasePracticeReportNew2Component.prototype.linkToPostSurvey = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
        })
            .subscribe(function (result) {
            _this.learningPathMetaId = result.data;
            _this.apiService
                .getOrCreateLearningPath(_this.learningPathMetaId)
                .subscribe(function (result) {
                _this.learningPath = result;
                if (_this.learningPath.subItems.length == 3) {
                    _this.apiService
                        .ajax({
                        type: "get",
                        url: "/sr/learningtour",
                    })
                        .subscribe(function (result) {
                        _this.learningTour = result;
                        var link = ["survey", _this.learningTour.tour_id, 3, 2];
                        _this.router.navigate(link);
                    });
                }
                else {
                    var link = [
                        "survey",
                        _this.learningPath.id,
                        _this.learningPath.subItems[4].surveyMetaId,
                        1,
                    ];
                    _this.router.navigate(link);
                }
            });
        });
    };
    return CasePracticeReportNew2Component;
}());
export { CasePracticeReportNew2Component };



// WEBPACK FOOTER //
// ./src/app/case-practice-report-new-2/case-practice-report-new-2.component.ts.pre-build-optimizer.js